import { Injectable, InjectionToken, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AvailableTimesResponse, DisabledDatesResponse } from '@interfaces/professional-booking';
import { ServicePageService } from './servicePage.service';

/**
 * Where the service booking pickers (`pages/page-service/booking-tabs/`) load availability from. By default
 * the product endpoints; a page that books something else (the professional service page) provides its own
 * implementation, so the pickers are reused unchanged (PROFESSIONAL_BOOKING_PLAN.md Phase 5, D10).
 */
export interface ServiceBookingApi {
    /** At most one time slot per booking (professional services: capacity 1, one line per order). */
    readonly singleSlot: boolean;
    getDisabledDates(serviceId: string, start: string, end: string): Observable<DisabledDatesResponse>;
    getAvailableTimes(serviceId: string, date: string): Observable<AvailableTimesResponse>;
}

@Injectable({ providedIn: 'root' })
export class ProductBookingApiService implements ServiceBookingApi {
    readonly singleSlot = false;

    constructor(private servicePageService: ServicePageService) { }

    getDisabledDates(serviceId: string, start: string, end: string): Observable<DisabledDatesResponse> {
        return this.servicePageService.getDisabledDates(serviceId, start, end);
    }

    getAvailableTimes(serviceId: string, date: string): Observable<AvailableTimesResponse> {
        return this.servicePageService.getAvailableTimes(serviceId, date);
    }
}

export const SERVICE_BOOKING_API = new InjectionToken<ServiceBookingApi>('SERVICE_BOOKING_API', {
    providedIn: 'root',
    factory: () => inject(ProductBookingApiService)
});
